import { Col, Container, Row } from "reactstrap";

const Scholarship = () => {
  return (
    <section className="section" id="scholarship">
      <Container>
        <Row className="">
          <Col xs='12' lg='5'>
          <img
            src="assets/images/scholarship.webp" 
            alt="students-apply-for-scholarship-illustration"
            className="img-fluid" 
            loading="lazy" 
          />
          </Col>
          <Col xs='12' lg='7'>
            <h1 className="mt-3 mt-lg-0 mb-3">Info Beasiswa</h1>
            <div>
              <h2><b>International Priority Program Scholarship</b></h2>
              <p>
                Northern Lights College menyediakan berbagai scholarship, 
                bursaries, dan awards bagi mahasiswa internasional dan domestik 
                melalui Northern Lights College Foundation untuk bantu biaya studi. 
                Kriteria & detail selengkapnya tersedia di website resmi atau foundation mereka.                
              </p>
            </div>  
            <p className="note">*Tips: Beberapa beasiswa punya nilai variatif (mulai dari potongan tuition sampai bantuan biaya hidup), daftar secepat mungkin supaya peluangnya makin besar.</p>         
          </Col>          
        </Row>
      </Container>
    </section>
  );
};

export default Scholarship;